export default "__VITE_ASSET__D0t_ab5m__"